export function useSiteLanguages() {
  const { sites } = useSite()
  const activeEntity = useActiveEntity()

  const languages = computed(() => {
    const hash = ref(randomString(10))
    return sites.value.map((locale) => {
      if (activeEntity.value?.links?.hasOwnProperty(locale.code)) {
        return {
          hash: hash.value,
          code: locale.code,
          name: locale.name,
          link: activeEntity.value.links[locale.code]
        }
      } else {
        return {
          hash: hash.value,
          code: locale.code,
          name: locale.name,
          link: `${useRequestURL().protocol}//${locale.domain}`
        }
      }
    })
  })

  return { languages }
}
